import Resources from "./Resources";
import Activity from "./Activity";

export default {
  resources: Resources,
  activity: Activity,
};
